<script setup lang="ts">
useDefaultMeta({
  title: 'WhatsApp Follow-up KiriminAja | Cek Status Paket Otomatis',
  description:
    'Kirim update status pengiriman otomatis lewat WhatsApp. Praktis, pelanggan tahu setiap status kiriman real-time. Coba WhatsApp Follow-up KiriminAja sekarang!',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Apakah WhatsApp Follow-up bisa digunakan untuk semua ekspedisi?',
    answer:
      'Bisa. KiriminAja sudah terintegrasi dengan seluruh ekspedisi partner, sehingga notifikasi otomatis dikirim sesuai update status pengiriman dari masing-masing kurir.'
  },
  {
    question: 'Bisakah saya mengubah isi pesan WhatsApp?',
    answer:
      'Bisa. Kamu bisa menyesuaikan sapaan, gaya bahasa, hingga menambahkan link review atau CTA sesuai karakter brand.'
  },
  {
    question: 'Apakah fitur ini berbayar?',
    answer:
      'Tidak. WhatsApp Follow-up tersedia gratis untuk semua member aktif KiriminAja.'
  },
  {
    question: 'Bisa digunakan untuk beberapa toko?',
    answer:
      'Bisa! Fitur ini mendukung <i>multi-brand management</i> dalam satu akun dashboard.'
  },
  {
    question:
      'Bagaimana kalau nomor WhatsApp saya berbeda dari akun KiriminAja?',
    answer:
      'Tidak masalah. Sistem KiriminAja bisa terhubung dengan nomor WhatsApp bisnis mana pun yang kamu gunakan.'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Status Pengiriman Paket Langsung di Whatsapp Komunikasi Otomatis"
      sub-title="Whatsapp Follow-up"
      description="Dengan WhatsApp Follow-up KiriminAja, pelanggan tahu setiap update status pengiriman, sementara kamu bisa fokus pada hal yang lebih penting — tanpa perlu kirim chat manual satu per satu."
      hero-image="/images/wafu-banner-1.webp"
      button-label="Aktifkan Sekarang"
      :button-link="
        $utm.utmUrl('/login', {
          redirectTo: '/settings/whatsapp-fu'
        })
      "
    />

    <KeunggulanWafuSection1 />
    <KeunggulanWafuSection2 />
    <KeunggulanWafuSection3 />
    <KeunggulanWafuSection4 />
    <FaqBase :faqs="faqs" />
    <KeunggulanWafuCta />
  </div>
</template>
